import { hiddenContentStyle } from '../../Styling';
export var getStyles = function () {
    return {
        screenReaderText: hiddenContentStyle
    };
};
//# sourceMappingURL=Announced.styles.js.map